import React, { memo, useEffect, useRef, useState } from 'react'
import Modal from "react-modal"
import styles from './OptionsModal.module.scss'
import { ReactComponent as GalleryIcon } from "assets/svg/gallery-icon.svg"
import { ReactComponent as CameraIcon } from "assets/svg/camera-svgrepo-com.svg"
import CameraCaptureModal from '../CameraCapture/CameraCaptureModal'

const OptionsModal = ({ optionModalOpen, setOptionModalOpen, setCameraModalOpen, setImageGalleryData, setImageData, video = false }) => {

    const handleCameraOption = () => {
        setImageData([])
        setImageGalleryData("")
        setCameraModalOpen(true);
        setOptionModalOpen(false);
    }
    // const [filePreview, setFilePreview] = useState(null);
    const fileInputRef = useRef(null);
    // const [fileName, setFileName] = useState(null);

    const handleFileChange = (event) => {
        setImageData([])
        setImageGalleryData("")
        const file = event.target.files[0];
        if (file) {
            // setFileName(file.name);
            if (file.type.startsWith('image/')) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    // setFilePreview(e.target.result);
                    setImageGalleryData(e.target.result)
                };
                reader.readAsDataURL(file);
                setOptionModalOpen(false);
            } else if (file.type.startsWith('video/')) {
                setImageGalleryData(file?.name);
                setOptionModalOpen(false);
            }
            else {
                // setFilePreview(null);
                setImageGalleryData(null)
                setOptionModalOpen(false);
            }
        }
    };

    const handleDivClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };


    return (
        <Modal
            isOpen={optionModalOpen}
            onRequestClose={() => setOptionModalOpen(false)}
            contentLabel="Camera Modal"
            className={styles.modal}
            overlayClassName={styles.overlay}
        >
            <div className={styles.cameraContainer}>
                <h3>Add {video ? "Video" : "Photo"} From</h3>
                <div className={styles.cameraiconsContainer} onClick={handleCameraOption}>
                    <CameraIcon className={styles.cameraicon} />
                    <p>Camera</p>
                </div>
                <div
                    className={styles.galleryiconsContainer}
                    onClick={handleDivClick}
                >
                    <GalleryIcon className={styles.galleryicon} />
                    <p>Gallery</p>
                    {/* Hidden file input */}
                    <input
                        type="file"
                        ref={fileInputRef}
                        accept={video && "video/*"}
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                    />
                </div>
                <div className={styles.cancelButton} onClick={() => setOptionModalOpen(false)}>Cancel</div>
                {/* {filePreview && (
                    <div className={styles.filePreviewContainer}>
                        <img
                            src={filePreview}
                            alt="File Preview"
                            className={styles.filePreviewImage}
                        />
                    </div>
                )}
 */}

            </div>
        </Modal>
    )
}

export default memo(OptionsModal)
